const LOCAL_HOSTS = new Set(['127.0.0.1', 'localhost']);
const FIXTURE_HASH = '#maryssil-test-unavailable';
const FIXTURE_ATTRIBUTE = 'data-maryssil-preview-fixture';

const isFixtureEnabled = () =>
  LOCAL_HOSTS.has(window.location.hostname) && window.location.hash === FIXTURE_HASH;

const createUnavailableMessage = () => {
  const message = document.createElement('p');
  message.className = 'maryssil-card-unavailable';
  message.setAttribute('role', 'status');
  message.textContent = 'Conjunto indisponível';
  return message;
};

const markCardUnavailable = (card) => {
  if (card.getAttribute(FIXTURE_ATTRIBUTE) === 'unavailable') return;

  card.setAttribute(FIXTURE_ATTRIBUTE, 'unavailable');
  card.dataset.maryssilSetAvailability = 'unavailable';

  const productCard = card.querySelector('product-card');
  if (!productCard) return;

  productCard.classList.add('product-card--unavailable-set');
  productCard.dataset.maryssilSetAvailability = 'unavailable';

  const price = productCard.querySelector('.maryssil-paired-price, .maryssil-card-price');
  price?.replaceWith(createUnavailableMessage());

  const action = productCard.querySelector('.maryssil-card-action');
  if (action) {
    action.classList.add('maryssil-card-action--unavailable');
    action.innerHTML = 'Ver detalhes <span>→</span>';
  }

  productCard.querySelectorAll('quick-add-component').forEach((quickAdd) => {
    quickAdd.hidden = true;
    quickAdd.setAttribute('aria-hidden', 'true');
  });

  const link = productCard.querySelector('a.product-card__link');
  if (link) {
    const url = new URL(link.href, window.location.href);
    url.hash = FIXTURE_HASH;
    link.href = url.toString();
  }
};

const applyCollectionFixture = () => {
  const results = document.querySelector(
    "results-list[data-bikini-sets-mode='native'], results-list[data-bikini-sets-mode='legacy']"
  );
  if (!results) return;

  const setCards = [...results.querySelectorAll('.product-grid__item[data-maryssil-card-kind="set"]')];
  setCards.slice(0, 2).forEach(markCardUnavailable);
};

const applyProductFixture = () => {
  const pairedPurchase = document.querySelector(
    '.maryssil-paired-purchase:not(.maryssil-paired-purchase--unavailable)'
  );
  if (!pairedPurchase) return;

  const fixture = document.createElement('div');
  fixture.className = 'maryssil-paired-purchase maryssil-paired-purchase--unavailable';
  fixture.setAttribute(FIXTURE_ATTRIBUTE, 'unavailable');
  fixture.dataset.maryssilSetAvailability = 'unavailable';
  fixture.setAttribute('role', 'status');

  const message = document.createElement('p');
  message.className = 'maryssil-paired-purchase__unavailable-message';
  message.textContent = 'Este conjunto está indisponível no momento.';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'button button-secondary';
  button.disabled = true;
  button.setAttribute('aria-disabled', 'true');
  button.textContent = 'Conjunto indisponível';

  fixture.append(message, button);
  pairedPurchase.replaceWith(fixture);
};

const applyFixture = () => {
  if (!isFixtureEnabled()) return;
  applyCollectionFixture();
  applyProductFixture();
};

if (isFixtureEnabled()) {
  const scheduleFixture = () => window.requestAnimationFrame(applyFixture);
  const observer = new MutationObserver(scheduleFixture);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixture, { once: true });
  } else {
    applyFixture();
  }

  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('hashchange', applyFixture, { passive: true });
}
